import { useTranslate } from '@va/localization';
import { GrayGradientDivider, ModalHeader } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import classNames from 'classnames';
import {
  CreationSteps,
  CustomTrackingCodeDomainCreationCtxParams,
  CustomTrackingCodeDomainCreationCtxProvider,
  useCustomTrackingCodeDomainCreationCtx,
} from './custom-tracking-code-domain-creation-context';
import { ConfirmEffectsStep } from './steps/ConfirmEffectsStep';
import { VerifyDnsStep } from './steps/VerifyDnsStep';

export const CustomTrackingCodeDomainCreationModal = ({
  isOpen,
  closeModal,
  domain,
  onSuccess,
  customDomainId,
}: {
  isOpen: boolean;
} & CustomTrackingCodeDomainCreationCtxParams) => {
  const translate = useTranslate();

  return (
    <ModalWrapper closeModal={closeModal} isModalOpen={isOpen}>
      <ModalHeader
        title={translate('standalone.customDomains.trackingCode.confirmDomainChange.title')}
        onClose={closeModal}
        className={'overflow-hidden'}
        titleClassName={'truncate'}
      />
      <CustomTrackingCodeDomainCreationCtxProvider
        customDomainId={customDomainId}
        onSuccess={onSuccess}
        closeModal={closeModal}
        domain={domain}
      >
        <ModalContent />
      </CustomTrackingCodeDomainCreationCtxProvider>
    </ModalWrapper>
  );
};

const ModalContent = () => {
  const { activeStep } = useCustomTrackingCodeDomainCreationCtx();

  return (
    <div className={classNames('max-w-[46.875rem] w-screen')}>
      <GrayGradientDivider />
      {activeStep === CreationSteps.verifyDNS && <VerifyDnsStep />}
      {activeStep === CreationSteps.confirmEffects && <ConfirmEffectsStep />}
    </div>
  );
};
